import { useUserSetting } from "core/hooks/useUserSetting";
import { useRouter } from "next/router";

export function usePreferredLocale() {
  const { locale, defaultLocale } = useRouter();
  const defaultValue = locale ?? defaultLocale ?? "en";
  return useUserSetting("locale", defaultValue);
}
